import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../../Components/SideBar/sideBar";
import Header from "../../Components/Header/header";
import { changeCardFalse } from "../../Redux/store/selectedCard";
import { useDispatch, useSelector } from "react-redux";
import useAutoLogout from "../../Components/custom-logout/custom-logout";

const AdminDashboard = ({ children }) => {
  const [selectedMenuId, setSelectedMenuId] = useState(1);
  const roleName = useSelector((state) => state.user.roleName);
  const [isMobile, setIsMobile] = useState(
    window.outerWidth <= 768 ? true : false
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const logout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshJwtToken");
  };

  useAutoLogout(logout);
  const handleMenuChange = (menuId) => {
    setSelectedMenuId(menuId);

    // Navigate to different routes based on menu selection
    let routes = {};
    if (roleName == "super_admin") {
      routes = {
        1: "/",
        2: "/my-profile",
        3: "/customer-list",
        4: "/advisor-list",
        5: "/investment-list",
        6: "/investment-request-list",
        7: "/stock-list",
        8: "/product-approval",
        9: "/inspecie-transfer-request",
        10: "/product-settings",
        11: "/roles-permissions",
      };
    } else if (roleName == "advisor") {
      routes = {
        1: "/",
        2: "/my-profile",
        3: "/customer-list",
        4: "/sub-advisor-list",
        5: "/investment-list",
        6: "/stock-list",
      };
    } else if (roleName == "sub_advisor") {
      routes = {
        1: "/",
        2: "/my-profile",
        3: "/customer-list",
        4: "/investment-list",
        5: "/stock-list",
      };
    }
     else if (roleName == "team") {
      routes = {
        1: "/",
        2: "/customer-list",
      };
    }
     else {
      routes = {
        1: "/",
        2: "/my-profile",
        3: "/customer-list",
        4: "/advisor-list",
        5: "/investment-list",
        6: "/investment-request-list",
        7: "/stock-list",
        8: "/product-approval",
        9: "/inspecie-transfer-request",
        10: "/product-settings",
      };
    }

    if (menuId == 1) {
      dispatch(changeCardFalse());
    }
    const targetRoute = routes[menuId];

    let redirectState = {
      path: targetRoute,
      state: {
        from: location.pathname,
      },
    };
    sessionStorage.setItem("redirectAfterLogin", JSON.stringify(redirectState));

    navigate(targetRoute, { state: { from: location.pathname } });
  };
  const handleBack = () => {
    const historyStack = location.state?.historyStack || [];
    const lastRoute =
      historyStack.length > 0 ? historyStack[historyStack.length - 1] : "/";

    navigate(lastRoute, {
      state: {
        fromViewHistory: true,
        historyStack: historyStack.slice(0, historyStack.length - 1),
      },
    });
  };
  // Show button after scrolling 100px
  useEffect(() => {
    const handleScroll = () => {
      console.log("I am main scrolling");
      setShowScrollTop(window.scrollY > 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="flex bg-[#F0F0F0]">
      {location.pathname != "/onboarding" && (
        <Sidebar
          toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
          isMenuOpen={isMenuOpen}
          isMobile={isMobile}
          onSideMenupChange={handleMenuChange}
        />
      )}
      <div
        className={`flex flex-col flex-grow overflow-auto ${
          isMobile
            ? isMenuOpen
              ? "opacity-30 overflow-hidden"
              : "opacity-100"
            : "opacity-100"
        } `}
      >
        {location.pathname != "/onboarding" && (
          <Header
            toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
            isMenuOpen={isMenuOpen}
            isMobile={isMobile}
            currentScreen={location.pathname}
            onBack={handleBack}
            logoutCallback={logout}
          />
        )}

        <div className={`${location.pathname != "/onboarding" ? "p-4" : ""}`}>
          {children}
        </div>
        {showScrollTop && (
          <button
            onClick={scrollToTop}
            className="font-medium fixed bottom-6 right-6 z-50 bg-black text-white px-4 py-2 rounded-full shadow-lg hover:bg-gray-800"
          >
            ↑
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
